module.exports = __webpack_public_path__ + "img/BET365.GR.ba845288.svg";